import styled from 'styled-components/macro';

export const IconWrapper = styled.div`
  margin-top: 0.35rem;
  margin-right: ${({ theme }) => theme.spacing.zero_1};
  margin-left: ${({ theme }) => theme.spacing.zero_1};

  cursor: pointer;
`;

export const BackText = styled.h5`
  color: ${({ theme }) => theme.colors.black_60};
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
`;
